import React, {FC} from 'react';
import {NavLink} from 'react-router-dom';
import {ReactSVG} from 'react-svg';

import {logo2, phone} from '../../assets';

import './style.scss';

type PropsTypes = {
	isOpenMenu: boolean;
	menuHandler: (boolean) => void;
	isOpenContacts: boolean;
	setIsOpenContacts: (boolean) => void;
};

const Header: FC<PropsTypes> = ({isOpenMenu, menuHandler, isOpenContacts, setIsOpenContacts}) => {
	const onClickContacts = () => {
		if (isOpenMenu) {
			menuHandler(false);
		}
		setIsOpenContacts(!isOpenContacts);
	};

	const onClickBurger = () => {
		if (isOpenContacts) {
			setIsOpenContacts(false);
		}
		menuHandler(!isOpenMenu);
	};

	return (
		<div className="header">
			<button type="button" className="burger" onClick={onClickBurger}>
				<span />
				<span />
				<span />
			</button>
			<div className="header__title">
				<div className="companyName">
					<div className="name">
						<p>OOO &#34;ТЛК ДиСав&#34;</p>{' '}
						<NavLink className="logo" to="/home">
							<ReactSVG src={logo2} alt="Logo" className="logo" />
						</NavLink>
					</div>
					<span>OOO &#34;Транспортно-логистическая комания ДиСав&#34;</span>
					<span> 220048 г.Минск, ул.Мясникова 39, пом.1</span>
				</div>
				<div className="companyTel">
					<div>
						<a href="tel:+375173904417">тел./факс: +375 (17) 390-44-17</a>
					</div>
					<div>
						<a href="mailto:office.disav@gmail.com">office.disav@gmail.com</a>
					</div>
				</div>
			</div>
			<button className="contacts" onClick={onClickContacts} type="button">
				<span>Контакты</span>
				<ReactSVG src={phone} alt="logo_phone" className="logo_phone" />
			</button>
		</div>
	);
};

export default Header;
